<template>
  <div id="botModal" class="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center p-4 hidden">
    <div class="bg-[#0C1020] w-full max-w-md rounded-2xl p-6 shadow-2xl border border-[#d600c0] relative text-white">
      <button class="absolute top-4 right-4 text-gray-400 hover:text-[#d600c0] text-xl" @click="fechar">×</button>

      <h2 class="text-xl font-semibold mb-4">
        {{ etapa === 1 ? 'Antes de Continuar' : 'Nova Stake' }}
      </h2>

      <div v-if="etapa === 1">
        <p class="text-sm text-gray-300 mb-4 leading-relaxed">
          Ao iniciar uma nova stake, você concorda que caso deseje cancelar antes do vencimento, será cobrada uma taxa
          de <span class="text-[#d600c0] font-bold">40%</span> sobre o valor investido.
        </p>
        <label class="flex items-center space-x-2 mb-6">
          <input v-model="aceito" type="checkbox" class="accent-[#d600c0] w-4 h-4" />
          <span class="text-sm text-gray-300">Li e aceito os termos acima</span>
        </label>

        <button
          :disabled="!aceito"
          class="bg-[#d600c0] hover:bg-[#b100a5] disabled:opacity-50 text-white font-semibold w-full py-2 rounded-md transition"
          @click="etapa = 2"
        >
          Continuar
        </button>
      </div>

      <!-- Etapa 2: Escolha do Período e Valor -->
      <div v-else>
        <div class="mb-4">
          <label class="block text-sm text-gray-400 mb-1">Escolha o período</label>
          <select v-model="dias" class="bg-[#10182C] text-white border border-[#2D3A5C] rounded-md w-full px-3 h-10">
            <option :value="30">30 dias - 40%</option>
            <option :value="60">60 dias - 90%</option>
            <option :value="365">1 ano - 300%</option>
          </select>
        </div>

        <div class="mb-4">
          <label class="block text-sm text-gray-400 mb-1">Valor a investir</label>
          <input
            v-model.number="valor"
            type="number"
            min="20"
            class="bg-[#10182C] text-white border border-[#2D3A5C] rounded-md w-full px-3 h-10"
            placeholder="Digite o valor a investir (mín. R$ 20)"
          />
        </div>

        <div class="text-sm text-gray-300 mb-6">
          Lucro estimado:
          <span class="text-[#d600c0] font-bold">
            {{ lucroEstimado.toFixed(2) }}
          </span>
        </div>

        <button
          class="bg-[#d600c0] hover:bg-[#b100a5] text-white font-semibold w-full py-2 rounded-md transition"
          @click="confirmarStake"
        >
          Confirmar Stake
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useAppStore } from '../../stores/integration'
import { useToast } from 'vuestic-ui'

const { init } = useToast()

const appStore = useAppStore()

const etapa = ref(1)
const aceito = ref(false)
const dias = ref(30)
const valor = ref(0)

function fechar() {
  appStore.hideBotModal()
  etapa.value = 1
  aceito.value = false
  dias.value = 30
  valor.value = 0
}

async function confirmarStake() {
  if (valor.value < 20) {
    init({ message: 'O valor mínimo para investir é $20.', color: 'danger' })
    return
  }
  const result = await appStore.newStake(valor.value, dias.value)
  if (result.success) {
    init({ message: result.message, color: 'success' })
    fechar()
  } else {
    init({ message: result.message, color: 'danger' })
  }
  fechar()
}

const lucroPorcentagem = computed(() => {
  switch (dias.value) {
    case 30:
      return 0.4
    case 60:
      return 0.9
    case 90:
      return 0.6
    case 180:
      return 1.4
    case 365:
      return 3.0
    default:
      return 0
  }
})

const lucroEstimado = computed(() => valor.value * lucroPorcentagem.value)
</script>
